/**
 * Splash Screen utility for iOS mobile app
 * Handles the native splash screen with space theme
 */

export async function hideSplashScreen() {
  try {
    if (window.Capacitor && window.Capacitor.Plugins.SplashScreen) {
      const { SplashScreen } = window.Capacitor.Plugins;
      
      // Wait a bit to show the beautiful splash
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Hide with fade animation
      await SplashScreen.hide({
        fadeOutDuration: 500
      });
      
      console.log('Splash screen hidden');
    }
  } catch (error) {
    console.log('Splash screen not available:', error);
  }
}

export async function showSplashScreen() {
  try {
    if (window.Capacitor && window.Capacitor.Plugins.SplashScreen) {
      const { SplashScreen } = window.Capacitor.Plugins;
      await SplashScreen.show({
        showDuration: 2000,
        autoHide: false
      });
    }
  } catch (error) {
    console.log('Splash screen not available:', error);
  }
}

